import fileDownload from "js-file-download";
import React from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { FaDownload, FaExclamationTriangle, FaUpload } from "react-icons/fa";

export function ConfigUploadJSONButton({
    disabled,
    onUpload,
    buttonText = "JSON Upload",
    className,
    variant = "outline-secondary",
    uploadIconClassName = "text-danger",
}) {
    const inputFile = React.useRef(null);
    let fileReader;
    const [error, setError] = React.useState(null);
    const [showModal, setShowModal] = React.useState(false);

    const handleFileRead = async () => {
        try {
            const text = fileReader.result;
            const data = JSON.parse(text);
            await onUpload(data);
        } catch (err) {
            setError(err.message);
            setShowModal(true);
        }

        // Clear the file input value after handling the file read (needed for Chrome)
        inputFile.current.value = null;
    };

    const handleFileChosen = (file) => {
        if (!file.name.endsWith(".json")) {
            setError("Invalid file format. Please upload a *.json file.");
            setShowModal(true);
            return;
        }

        fileReader = new FileReader();
        fileReader.onloadend = handleFileRead;
        fileReader.readAsText(file);
    };

    const onButtonClick = () => {
        inputFile.current.click();
    };

    const handleClose = () => {
        setShowModal(false);
    };

    return (
        <>
            <Form.Control
                type="file"
                style={{ display: "none" }}
                ref={inputFile}
                onChange={(e) => handleFileChosen(e.target.files[0])}
            />
            <Button
                disabled={disabled}
                variant={variant}
                onClick={onButtonClick}
                className={className}
            >
                <FaUpload className={`${uploadIconClassName} me-2`} />
                {buttonText}
            </Button>

            <Modal show={showModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <FaExclamationTriangle className="me-2" />
                        Error
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {error?.split("\n").map((line, idx) => (
                        // biome-ignore lint/suspicious/noArrayIndexKey: Error lines are positional, may contain duplicates, and have no stable identifier.
                        <React.Fragment key={idx}>
                            {line}
                            <br />
                        </React.Fragment>
                    ))}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export function ConfigDownloadJSONButton({
    filename,
    disabled,
    onDownload,
    buttonText = "JSON Download",
}) {
    async function handleDownload() {
        const jsonData = await onDownload();
        const stringData = JSON.stringify(jsonData, null, 4);
        fileDownload(stringData, `${filename}.json`);
    }

    return (
        <Button
            disabled={disabled}
            variant="outline-secondary"
            onClick={handleDownload}
        >
            <FaDownload className="text-success me-2" />
            {buttonText}
        </Button>
    );
}
